/* Controls loading bar visibility based on actions */

import { showLoading, hideLoading } from 'react-redux-loading-bar';

const defaultShowLoaderTypeSuffixes = ['REQUEST_START', 'LOCATION_CHANGE'];
const defaultHideLoaderTypeSuffixes = ['REQUEST_SUCCESS', 'REQUEST_FAILURE', 'CANCEL_QUERY', 'PAGE_LOAD'];

export default function loadingBar(config: any = {}) {
    const showLoaderPromiseTypeSuffixes = config.showLoaderPromiseTypeSuffixes || defaultShowLoaderTypeSuffixes;
    const hideLoaderPromiseTypeSuffixes = config.hideLoaderPromiseTypeSuffixes || defaultHideLoaderTypeSuffixes;

    return ({ dispatch }) => next => (action) => {
        if (action.type) {
            let dispatchShowLoading = showLoaderPromiseTypeSuffixes.some(x => {
                let re = new RegExp(`${x}$`, 'g');
                return action.type.match(re);
            });

            let dispatchHideLoading = hideLoaderPromiseTypeSuffixes.some(x => {
                let re = new RegExp(`${x}$`, 'g');
                return action.type.match(re);
            });

            if (dispatchShowLoading) { dispatch(showLoading()); }

            if (dispatchHideLoading) { dispatch(hideLoading()); }
        }

        return next(action);
    };
}



// WEBPACK FOOTER //
// ./src/middleware/loadingBar.tsx